import { createApiDescription } from "../../helperFunctions";

export const userManagementInfo = {
    addUser: createApiDescription(
        "This API can be called to add a new user to the User Management database.",
        [
            "All the location details with id's can be get using All Location API.",
        ]
    ),
    getAllUsers: createApiDescription(
        "This API can be called to get the list of users with various filters applied in the request.",
        [
            "User API provide results based on the given filters on the request parameters and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of returns in the response will be 10.",
        ]
    ),
    getAllUserGroups: createApiDescription(
        "This API can be used to get all user groups with role information present in the Firm.",
        ["This API will return the firm’s user groups and the roles assigned to that group."]
    ),
    deleteUser: createApiDescription(
        "This API can be called to delete existing user from the User Management.",
        [
            "User ID can be obtained from the GET User API.",
            "Deleted users will be permanently removed from the company account."
        ]
    ),
    editUser: createApiDescription(
        "This API can be used to edit existing user details in the User Management.",
        [
            "All the location details with id's can be get using All Location API.",
            "By giving empty value to the fields in the request will remove the existing value for the given fields.",
            "The fields first name, last name, email address, country code, office location, user groups cannot be deleted."
        ]
    ),
}